import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as ExcelJS from 'exceljs';

const EXCEL_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({ providedIn: 'root' })
export class ExcelService {
  constructor() {}

  public exportAsExcelFile(json: any[], fileName?: string): void {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('data1');
    worksheet.columns = Object.keys(json[0]).map(key => ({
      header: key,
      key: key,
    }));

    worksheet.addRows(json);

    workbook.xlsx.writeBuffer().then(buffer => {
      this.saveAsExcelFile(buffer, fileName);
    });
  }

  private saveAsExcelFile(buffer: any, fileName?: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });

    FileSaver.saveAs(
      data,
      (fileName || new Date().getTime().toString()) + EXCEL_EXTENSION
    );
  }
}
